import React, { useEffect } from "react";
import { Stack, Typography, Button, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Loader } from "../../../shared";
import InfoIcon from "@mui/icons-material/Info";

export default function FileUploadSection({
  tipsAndTricks,
  validator,
  handleInputChangeFile,
  onDeleteFileSelect,
  createImageFileUrl,
  videoRef,
}) {
  useEffect(() => {
    validator?.current?.purgeFields?.();
  }, [tipsAndTricks, validator]);

  return (
    <Stack>
      <Box
        sx={{
          backgroundColor: "#F5F8FC",
          padding: "8px",
        }}
      >
        <Typography fontSize="12px" fontWeight={600} p="8px">
          Files
        </Typography>
        <Box
          sx={{
            borderRadius: "6px",
            display: "flex",
            backgroundColor: "#FFFFFF",
            flexDirection: "column",
            border: 1,
            borderColor: "divider",
          }}
        >
          {tipsAndTricks?.data?.doc_url?.map((item, index) => (
            <Box
              key={index}
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "10px",
                borderBottom: 1,
                borderColor: "divider",
                px: "8px",
                height: "40px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "70%",
                  gap: "16px",
                }}
              >
                <img alt="file" src="/icons/ic_file.jpg" />
                <Typography
                  variant="body1"
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    flexGrow: 1,
                  }}
                >
                  {item?.doc_name}
                </Typography>
              </Box>
              <Button
                size="small"
                color="error"
                onClick={() => onDeleteFileSelect(index)}
              >
                Remove
              </Button>
            </Box>
          ))}

          {createImageFileUrl?.isPending ? <Loader /> : null}

          <Stack
            alignItems="start"
            justifyContent="center"
            p="8px"
            height="40px"
            borderColor="divider"
          >
            <Button
              variant="text"
              startIcon={<AddIcon />}
              component="label"
              size="small"
            >
              Add Files
              <input
                id="contained-button-file"
                type="file"
                onChange={handleInputChangeFile}
                onClick={(e) => {
                  e.target.value = null;
                }}
                style={{ display: "none" }}
                ref={videoRef}
              />
            </Button>
          </Stack>
        </Box>
      </Box>
      <Stack direction="row">
        <InfoIcon sx={{ height: "13px", color: "#485364", mt: 0.5 }} />
        <Typography color="#485364" fontSize="14px" fontWeight={400}>
          You can only PDF or video. Supported formats are PDF or MP4.
        </Typography>
      </Stack>
    </Stack>
  );
}
